import { createRoutine } from 'redux-saga-routines';
import { ACTION_APP_START } from '@/constants';

export default createRoutine(ACTION_APP_START);
